module.exports = __webpack_public_path__ + "static/media/viasat-hockey.225e3ca5.png";